import { Flex } from '@mantine/core';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import MeetingContact from 'components/shared/Meeting/MeetingList/MeetingCard/MeetingContact';
import MeetingBadge from 'components/shared/MeetingBadge';
import CustomLink from 'components/shared/form/CustomLink';
import FieldTextAndValue from 'components/shared/form/FieldTextAndValue/FieldTextAndValue';
import { ROUTES } from 'configs/routes';
import { leadDrawer, meetingDrawer } from 'stores/global/RootStore';
import { useAppConfig } from 'stores/global/RootStore/context';
import { createFullName } from 'utils/createFullName';

import s from './Detail.module.scss';

const Detail: React.FC = () => {
  const { meeting, close } = meetingDrawer;
  const navigate = useNavigate();
  const { logic } = useAppConfig();

  const handleLeadClick = React.useCallback(() => {
    if (meeting.value?.lead) {
      leadDrawer.open(meeting.value.lead.id);
      close();
    }
  }, [meeting.value?.lead, close]);

  const handleClientClick = React.useCallback(() => {
    if (meeting.value?.client) {
      navigate(ROUTES.lk.clients.detail.create(meeting.value.client.id));
      close();
    }
  }, [meeting.value?.client, navigate, close]);

  if (!meeting.value) {
    return null;
  }

  return (
    <Flex direction="column" gap="sm" p="md" className={s.root}>
      {logic.meeting.showStatus && <MeetingBadge status={meeting.value.status} />}
      <FieldTextAndValue
        label="Дата и время"
        valueString={`${dayjs(meeting.value.slot.startDate).format('DD.MM.YYYY')} • ${dayjs(meeting.value.slot.startDate).format('HH:mm')}`}
      />
      {meeting.value.lead && (
        <Flex gap="sm" align="end" className={s.root__lead}>
          <FieldTextAndValue
            label="Заявка"
            valueString={
              meeting.value.lead.placeType
                ? `#${meeting.value.lead.id} • ${meeting.value.lead.placeType.name}`
                : `#${meeting.value.lead.id}`
            }
          />
          <CustomLink as="button" onClick={handleLeadClick} label={'Посмотреть'} bg="none" />
        </Flex>
      )}
      <FieldTextAndValue label="Проект" valueString={meeting.value.project.name} />
      <MeetingContact
        className={s.contact}
        title="Клиент"
        fullName={createFullName(meeting.value.client)}
        onClick={handleClientClick}
        phone={meeting.value.manager.phone}
      />
      {meeting.value.lead && meeting.value.lead.subAgent && (
        <MeetingContact
          className={s.contact}
          title="Субагент"
          fullName={createFullName(meeting.value.lead.subAgent)}
          phone={meeting.value.lead.subAgent.phone}
        />
      )}

      <FieldTextAndValue label="Тип встречи" valueString={meeting.value.isOffline ? 'Оффлайн' : 'Онлайн'} />
      <MeetingContact
        className={s.contact}
        title="Ответственный"
        fullName={createFullName(meeting.value.responsible)}
        phone={meeting.value.responsible.phone}
      />
      <MeetingContact
        className={s.contact}
        title="Менеджер"
        fullName={createFullName(meeting.value.manager)}
        phone={meeting.value.manager.phone}
      />
    </Flex>
  );
};

export default observer(Detail);
